import { type ObservableValue } from '@amazon/vinyl-observable'
import { getMarketplace, marketplace$ } from '@/marketplace'
import { arePodcastsAvailable } from '@/territory'

/** Whether podcast surfaces are offered in the current market; GH's `arePodcastsAvailable()`. */
export const arePodcastsAvailable$: ObservableValue<boolean> = marketplace$.map((m) =>
    arePodcastsAvailable(m?.musicTerritory)
)

export async function loadArePodcastsAvailable(): Promise<boolean> {
    return arePodcastsAvailable((await getMarketplace()).musicTerritory)
}
